export const MAX_AGENT_CATEGORY_LENGTH = 50;
